import { render, staticRenderFns } from "./HistoricoEnvioAutomatico.vue?vue&type=template&id=276cf3e8&"
import script from "./HistoricoEnvioAutomatico.vue?vue&type=script&lang=js&"
export * from "./HistoricoEnvioAutomatico.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoEnvioAutomatico.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports